module.exports = __webpack_public_path__ + "static/img/icn_folder_3d.d5d19fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_folder_3d.png
// module id = l0Kq
// module chunks = 1